import { useQuery, UseQueryResult } from 'react-query'

import { useProjectService } from 'features/project/service'

export const useProjectList = (): UseQueryResult => {
  const projectService = useProjectService()

  return useQuery(['project-search'], () => projectService.fetchProjects(), {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  })
}
